import { getInputFocusStyle } from '@fluentui/react';
export var SearchBoxStyles = function (props) {
    var theme = props.theme, hasFocus = props.hasFocus, underlined = props.underlined;
    if (!theme) {
        throw new Error('theme is undefined or null in base SearchBox getStyles function.');
    }
    return {
        root: [
            hasFocus && [
                'is-active',
                {
                    position: 'relative'
                },
                getInputFocusStyle(theme.palette.themePrimary, underlined ? 0 : theme.effects.roundedCorner2, underlined ? 'borderBottom' : 'border')
            ]
        ]
    };
};
//# sourceMappingURL=SearchBox.styles.js.map